<template>
  <div class="row mt-2">
    <template v-for="event in evenements">
      <b-form-group
        :label="$t(event.label)"
        :label-for="event.type + '-input'"
        class="col-md-6 medium-label mb-4">
        <datepicker-input
          :id="event.type + '-input'"
          v-model="event.date"
          v-on:input="emitChangeValue">
        </datepicker-input>
      </b-form-group>
    </template>
  </div>
</template>


<script>
import DatepickerInput from "../../components/b122/editFields/DatepickerInput.vue";

export default {
  name: "EvenementCreateEditOperation",

  components: {
    DatepickerInput
  },

  emits: ['didChangeValue'],

  props: {
    evenements: Object
  },

  methods: {
    async emitChangeValue() {
      this.$emit('didChangeValue')
    },
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/views/operationPlanning/EvenementCreateEditOperation.vue